// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
import { capitalCase } from 'change-case';
import useAuth from '../../../hooks/useAuth';
import createAvatar from '../../../utils/createAvatar';


// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { user } = useAuth();

  return (
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        <Avatar
          src={user?.photo}
          color={user?.photo ? 'default' : createAvatar(user?.nome).color}
          alt={user?.nome}
        >
           {createAvatar(user?.nome).name}
        </Avatar>

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
            overflow:'auto',
          }}
        >
          <Typography variant="body2" fontWeight='bold' noWrap>
            {user?.nome}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
